// AppRouter.tsx
import React, { Suspense, lazy } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";

import AccountLayout from "./layouts/AccountLayout";
import ScrollToTop from "./components/ScrollToTop";

const LandingPage = lazy(() => import("./pages/Landing"));
const SearchPage = lazy(() => import("./pages/Search"));
const DetailPage = lazy(() => import("./pages/Detail"));
const AboutUsPage = lazy(() => import("./pages/AboutUs"));
const PrivacyPolicyPage = lazy(() => import("./pages/PrivacyPolicy"));
const FAQPage = lazy(() => import("./pages/Faq"));
const ContactPage = lazy(() => import("./pages/Contact"));
const InventoryPage = lazy(() => import("./pages/Inventory"));

const AppRouter: React.FC = () => {
  return (
    <Router>
      <ScrollToTop />
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          <Route path='/' element={<LandingPage />} />
          <Route path='/search' element={<SearchPage />} />
          <Route path='/:slug' element={<DetailPage />} />
          <Route path='/inventory' element={<InventoryPage />} />

          <Route path='/contact' element={<ContactPage />} />
          <Route path='/about-us' element={<AboutUsPage />} />
          <Route path='/privacy-policy' element={<PrivacyPolicyPage />} />
          <Route path='/faq' element={<FAQPage />} />

          <Route path='account/*' element={<AccountLayout />} />

          <Route path='*' element={<Navigate to='/' />} />
        </Routes>
      </Suspense>
    </Router>
  );
};

export default AppRouter;
